<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" @submit.native.prevent>
            <el-form-item prop="content" label-width="0px">
                <el-input v-model.trim="searchForm.content" maxlength="50" placeholder="请输入版本信息"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="operationBefore" label="操作前" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operationAfter" label="操作后" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operation" label="操作" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <div>{{ row.operation == 0 ? '新增' : row.operation == 1 ? '编辑' : '删除' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createByName" label="操作人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="操作时间" sortable="custom" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
    </div>
</template>

<script>

export default {
    name: "version",
    data() {
        return {
            searchForm: {
                content: '',
                current: 1,
                size: 20,
            },
            total: 0,
            sort:'',
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect,sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            this.$axios(this.api.allCommon.commonWatermarkHistoryList, {
                ...this.searchForm,
                sort:this.sort,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 列表排序
        sortChange(column) {
            if (column.order){
                let minSort = ''
                if (column.prop == 'createTime'){
                    minSort = column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
                    this.sort = 'create_time ' + minSort
                }
                this.refreshList(1,1)
            }else {
                this.sort = ''
                this.refreshList(1,1,1)
            }
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1,1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },
    },
}
</script>

<style scoped>

</style>
